module.exports = __webpack_public_path__ + "assets/img/1621589449039_.pic_hd.9e1009ee.jpg";